import HTMLTemplate from './template.html'
import './styles.scss'

export const AirspacePopupComponent = (() => {
    var vueComponent = {
        data() {
            return {
                leftPosition: 0,
                topPosition: 0,
                display: 'none',
                name: '',
                code: '',
                highestRestrictionLevel: 0
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-airspace-popup')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();

